export default "__VITE_PUBLIC_ASSET__c852e7d1__"